import "./App.css";
import TVChartContainer from "./advanced_chart";
function App() {
  return (
    <div className="App">
      <TVChartContainer />
    </div>
  );
}

export default App;
